/*
 * Collapsible content — "Fight Card".
 *
 * The panel sizes itself in CSS (grid-template-rows 0fr -> 1fr), so this file
 * only owns state: the `active` class on the row and `aria-expanded` on its
 * button. It deliberately does not touch display/hidden or measure heights —
 * doing so would kill the transition and pin the panel to a stale pixel value.
 *
 * `inert` is the one thing set on the panel itself. The CSS already hides a
 * closed panel's content from the tab order via a delayed `visibility`, but
 * that depends on the transition actually completing; inert guarantees it
 * regardless, and unlike display/hidden it does not affect layout.
 *
 * Behaviour preserved from the previous version: one row open at a time, and
 * re-initialisation on shopify:section:load for the theme editor.
 */
(function () {
	function setState(button, open) {
		const item = button.closest(".collapsible-content__item");
		const panel = document.getElementById(button.getAttribute("aria-controls"));
		button.setAttribute("aria-expanded", open ? "true" : "false");
		item?.classList.toggle("active", open);
		if (panel) panel.inert = !open;
	}

	function init(root = document) {
		root.querySelectorAll(".collapsible-content__toggle:not([data-collapsible-ready])").forEach((button) => {
			button.dataset.collapsibleReady = "true";
			setState(button, button.getAttribute("aria-expanded") === "true");

			button.addEventListener("click", () => {
				const willOpen = button.getAttribute("aria-expanded") !== "true";
				const group = button.closest(".collapsible-content__items");
				group?.querySelectorAll(".collapsible-content__toggle[aria-expanded='true']").forEach((openButton) => {
					if (openButton !== button) setState(openButton, false);
				});
				setState(button, willOpen);
			});
		});
	}

	document.addEventListener("shopify:section:load", (event) => init(event.target));
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => init(), { once: true });
	} else {
		init();
	}
})();
